import type { VisitChecklistItem } from '../types/index.ts';

type PhotoTask = Pick<
  VisitChecklistItem,
  'id' | 'due' | 'requiresPhoto' | 'status' | 'note' | 'photoIds' | 'notApplicableApproved'
>;

export function photoTaskNotApplicable(item: PhotoTask): boolean {
  return item.status === 'not_applicable' && item.notApplicableApproved === true && Boolean(item.note?.trim());
}

export function missingRequiredPhotoItems<T extends PhotoTask>(items: readonly T[]): T[] {
  return items.filter(
    (item) => item.due && item.requiresPhoto && !photoTaskNotApplicable(item) && item.photoIds.length === 0,
  );
}

/** A required task with a photo still blocks later tasks until it is done. */
export function precedingPhotoBlocker<T extends PhotoTask>(items: readonly T[], itemId: string): T | null {
  for (const item of items) {
    if (item.id === itemId) return null;
    if (
      item.due &&
      item.requiresPhoto &&
      !photoTaskNotApplicable(item) &&
      (item.status !== 'done' || item.photoIds.length === 0)
    )
      return item;
  }
  return null;
}
